import AdminWrapper from '@/admin/components/addmin-wrapper/AdminWrapper';
import ServiceRequestComp from '@/admin/components/service-request-comp/ServiceRequestComp';
import DataNotFound from '@/components/data-not-found/DataNotFound';
import Spinner from '@/components/spinner/Spinner';
import {
    Table,
    TableBody,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table"
import useGetApiReq from '@/hooks/useGetApiReq';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const AdminPartnerRequests = () => {
    const { res, fetchData, isLoading } = useGetApiReq();

    const navigate = useNavigate();
    const params = useParams();

    const [requests, setRequests] = useState([]);

    const getPartnerDetail = useCallback(async () => {
        fetchData(`/admin/get-partner-details/${params?.partnerId}`);
    }, [params.partnerId, fetchData]);

    useEffect(() => {
        getPartnerDetail();
    }, []);

    useEffect(() => {
        if (res?.status === 200 || res?.status === 201) {
            console.log("partner", res?.data);
            setRequests(res?.data?.partner?.requests);
        }
    }, [res]);


    return (
      <AdminWrapper>
        <div>
          <div className="section-heading-container">
            <h1 className="section-heading">Requests</h1>
          </div>

          <Table className="mt-4 glass-header !border-white !border-2 !shadow-none">
            <TableHeader>
              <TableRow className="text-lg">
                <TableHead>Client Name</TableHead>
                <TableHead>Client Phone No</TableHead>
                <TableHead>Service Cost</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Date</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {requests?.map((request) => (
                <ServiceRequestComp
                  key={request._id}
                  serviceRequest={request}
                  getServiceRequests={getPartnerDetail}
                />
              ))}
            </TableBody>
          </Table>

          {requests.length === 0 && isLoading && <Spinner size={30} />}

          {requests.length === 0 && !isLoading && (
            <DataNotFound name={"Requests"} />
          )}
        </div>
      </AdminWrapper>
    );
}

export default AdminPartnerRequests